import {Box, Stack, Typography} from '@mui/material';
import {InputField} from '@/pages/components/common';
import {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import type {PafFormPage} from '@/pages/components/audit-program/paf-section/constants';
import ProgramSectionHeader from '@/pages/components/audit-program/a-section/ProgramSectionHeader';

export interface PafFormViewProps {
    header: AuditProgramSectionVO;
    page: PafFormPage;
    refCode: string;
    values: Record<string, string>;
    onChange: (key: string, value: string) => void;
}

/** Simple labelled field form for PAF02 / PAF03. */
export default function PafFormView({
    header,
    page,
    refCode,
    values,
    onChange,
}: PafFormViewProps) {
    return (
        <Box sx={{p: 2, maxWidth: 880}}>
            <ProgramSectionHeader
                header={header}
                variant="a12"
                refCode={refCode}
                values={values}
                onChange={onChange}
            />
            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{textAlign: 'center', letterSpacing: 0.3, mb: 2, mt: 0.5}}
            >
                {page.title}
            </Typography>
            <Stack spacing={1.5}>
                {page.fields.map((f) => (
                    <Box key={f.id}>
                        <Typography variant="body2" fontWeight={600} sx={{mb: 0.4}}>
                            {f.label}
                        </Typography>
                        <InputField
                            type="text"
                            fullWidth
                            compact
                            multiline={Boolean(f.multiline)}
                            minRows={f.minRows ?? 1}
                            value={values[f.id] ?? ''}
                            onChange={(e) => onChange(f.id, e.target.value)}
                        />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
